import { JsonSerializable } from "@/Common/Models/JsonSerializable";
import { WeightUnit } from "@/Common/Utilities/Units/Units";
import { WeightUnitConverter } from "@/Common/Utilities/Units/WeightUnitConverter";
import { BloodPressure } from "../MedicalSummary/BloodPressure";
import { MedicalItemVitalSign } from "../MedicalSummary/MedicalItemVitalSign";
import { GestationalAge } from "./GestationalAge";
import { ObstetricalFileVitalSign } from "./ObstetricalFileVitalSign";
import { PrenatalVisitInitials } from "./PrenatalVisitInitials";

class ObstetricalVisit extends JsonSerializable {
    private _vitalSign: ObstetricalFileVitalSign;
    private _id: number;

    public EmrTemplateId: string; // Weight and BP
    public Date?: Date;
    public GestationalAge: GestationalAge;
    public FetalHeartRate: string;
    public FetalMovement: string;
    public Presentation: string;
    public Comments: string;
    public NextVisit: string;
    public Initials: PrenatalVisitInitials;
    public ContributionId: string;

    constructor(fields?: Partial<ObstetricalVisit>) {
        super({ excludedFields: ["_id", "_vitalSign"] });
        Object.assign(this, fields);
        this._id = sessionStore.newId();
        this.GestationalAge = new GestationalAge(fields?.GestationalAge);
        this.Initials = new PrenatalVisitInitials(fields?.Initials);
    }

    public getId(): number {
        return this._id;
    }

    public get vitalSign(): ObstetricalFileVitalSign {
        return this._vitalSign;
    }

    public set vitalSign(vitalSign: ObstetricalFileVitalSign) {
        this._vitalSign = vitalSign;
        this.EmrTemplateId = vitalSign.emrTemplateId;
    }

    public get WeightInKg(): number {
        return this.vitalSign?.weightInKgs;
    }

    public set WeightInKg(value: number) {
        if (this.vitalSign)
            this.vitalSign.weightInKgs = value;
    }

    public get BloodPressure(): BloodPressure {
        return this.vitalSign?.bloodPressure;
    }

    public set BloodPressure(value: BloodPressure) {
        if (this.vitalSign)
            this.vitalSign.bloodPressure = value;
    }

    public getConvertedWeight(unit: WeightUnit): number {
        return WeightUnitConverter.convert(WeightUnit.Kilogram, unit, this.WeightInKg, 2);
    }

    public setWeight(value: number, unit: WeightUnit): void {
        this.WeightInKg = WeightUnitConverter.convert(unit, WeightUnit.Kilogram, value);
    }

    public updateVitalSignValueFromMedicalItem(vitalSign: MedicalItemVitalSign): void {
        this.vitalSign.updateValueFromMedicalItemVitalSign(vitalSign);
    }
}

export { ObstetricalVisit };
